import infoIcon from "./images/info.svg";
import styles from "./ProductNutritionalInfo.module.scss";

const ProductNutritionalInfo = ({ product }) => {
    return (
        <div className={styles.productNutritionalInfo}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Nutrition Facts</th>
                        <th>Per 100g (%)</th>
                        <th>Per Portion/250g</th>
                    </tr>
                </thead>
                <tbody>
                    {product.facts ? (
                        JSON.parse(product.facts).map((fact, index) => {
                            return (
                                <tr key={index}>
                                    <td>{fact.typical_value}</td>
                                    <td>{fact.p100}</td>
                                    <td>{fact.p250}</td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td style={{ textAlign: "center" }} colSpan={3}>
                                No nutritional information available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div>
                <p className="fs-4 p-3 m-0">We are updating this information. Please come back soon</p>
            </div>
            <div className={styles.liability_info}>
                <img src={infoIcon} height={20} alt="info" />
                <div>
                    No liability is assumed for the above information. Please check the information on the respective product packaging in
                    each individual case and the product label information is binding for the manufacturer. In case you find misinformation,
                    please{" "}
                    <span
                        style={{
                            textDecoration: "underline",
                            color: "var(--color-primary)",
                            fontWeight: "bold",
                            cursor: "pointer",
                        }}
                    >
                        Report us.
                    </span>{" "}
                </div>
            </div>
        </div>
    );
};

export default ProductNutritionalInfo;
